import { imageUrl } from "@/utils/constants";
import FA_LANG from "@/assets/locale/fa";
import { QuizProps } from "./Test";
import ResponseInput from "./inputs/ResponseInput";
import icons from "@/assets/icons";
import { useId } from "react";

export default function Matching({
  selectedQuiz,
  updateQuizDetail,
  updateQuestion,
  addNewChoice,
  removeChoice,
  questionDirection,
}: QuizProps) {
  const handleQuestionChange = (value: string, i: number) => {
    const updatedSelectedQuiz: Quiz = { ...selectedQuiz, question: value };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  };

  function handleQuestionFileChange(image: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_file: image,
      question_link: "",
      question_file_id: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }

  const addQuizDetails = (i: number) => {
    if (selectedQuiz.quiz_detail_json.length < 4) {
      addNewChoice!(
        {
          id: "choice" + (i + 1),
          choice: {
            fileId: "",
            text: "",
            url: "",
          },
          isCorrect: false,
          ordering: i + 1,
          correctOrder: i + 1,
          letterWise: false,
          isChoice: true,
          answers: [
            {
              id: "answer" + (i + 1) + "1",
              answer: {
                fileId: "",
                text: "",
                url: "",
              },
            },
          ],
        },
        i
      );
    }
  };

  const removeQuizDetails = (i: string) => {
    if (selectedQuiz.quiz_detail_json.length > 2) {
      removeChoice!(i);
    }
  };

  const handleAddInputs = (i: number) => {
    if (
      selectedQuiz.quiz_detail_json?.length > 0 &&
      selectedQuiz.quiz_detail_json?.length < 5
    ) {
      addQuizDetails(i);
    }
  };

  const handleDeleteInputs = (i: string) => {
    if (selectedQuiz.quiz_detail_json?.length > 2) {
      removeQuizDetails(i);
    }
  };

  const updateChoiceImage = (image: any, i: number) => {
    var updated = selectedQuiz.quiz_detail_json.map((details, index) =>
      i === index
        ? {
            ...details,
            choice: {
              ...details?.choice,
              url: undefined,
              fileId: image,
            },
          }
        : details
    );
    updateQuizDetail(updated[i]);
  };

  const updateAnswerImage = (image: any, i: number) => {
    var updated = selectedQuiz.quiz_detail_json.map((detail, index) =>
      index === i && detail?.answers
        ? {
            ...detail,
            answers: [
              {
                ...detail.answers[0],
                answer: {
                  ...detail.answers?.[0].answer,
                  url: undefined,
                  fileId: image,
                },
              },
            ],
          }
        : detail
    );
    updateQuizDetail(updated[i]);
  };

  const updateAnswerValue = (value: string, i: number) => {
    var updated = selectedQuiz.quiz_detail_json.map((detail, index) =>
      index === i && detail?.answers
        ? {
            ...detail,
            answers: [
              {
                ...detail.answers[0],
                answer: {
                  ...detail?.answers[0].answer,
                  text: value,
                },
              },
            ],
          }
        : detail
    );
    updateQuizDetail(updated[i]);
  };

  const updateChoiceValue = (value: string, i: number) => {
    var updated = selectedQuiz.quiz_detail_json.map((details, index) =>
      i === index
        ? { ...details, choice: { ...details.choice, text: value } }
        : details
    );
    updateQuizDetail(updated[i]);
  };

  const renderInputs = () => {
    return selectedQuiz.quiz_detail_json.map((itm, i) => (
      <div className="flex w-full items-center flex-grow  h-full" key={i}>
        <div className="flex p-[6px] flex-col justify-end items-end flex-grow self-stretch rounded-xl bg-green-10  h-full">
          <div className="flex flex-col justify-start items-end gap-[6px] flex-grow self-stretch h-full">
            <div className="flex justify-between items-center self-stretch">
              <div className="flex justify-start items-center gap-1  p-1 flex-col  rounded-[100px] bg-bg-white">
                {/* <div className="flex p-1 flex-col items-center gap-[10px] rounded-[100px] bg-bg-white">
                      <div className="flex justify-start items-center gap-1">
                        
                      </div>
                    </div> */}
                <div className="text-xs text-nowrap text-text-caption">
                  {FA_LANG.MATCHING_CHOICE} {i + 1}
                </div>
              </div>
              {selectedQuiz.quiz_detail_json.length > 2 && (
                <button
                  title={FA_LANG.DELETE_CHOICE_ALT}
                  className="flex justify-center items-center w-6 h-6 hover:bg-tertiary rounded-full"
                  onClick={() =>
                    handleDeleteInputs(selectedQuiz?.quiz_detail_json?.[i]?.id)
                  }
                >
                  {icons.closeSquare}
                </button>
              )}
            </div>
            <ResponseInput
              placeHolder={FA_LANG.CHOICE}
              styleClass="h-full"
              inputValue={itm?.choice?.text}
              valueUpdated={updateChoiceValue}
              index={i}
              hasFile={true}
              imageUrl={
                selectedQuiz?.quiz_detail_json && itm?.choice?.url
                  ? imageUrl + itm?.choice?.url
                  : selectedQuiz?.quiz_detail_json && itm?.choice?.fileId
                    ? URL.createObjectURL(itm?.choice?.fileId)
                    : undefined
              }
              handleImageChange={updateChoiceImage}
              imageHeight="h-full"
              id={`file-input-matching-choice-${image_id + i}`}
              tabIndex={i + 1}
            />
            <ResponseInput
              placeHolder={FA_LANG.CHOICE_ANSWER_PLACEHOLDER}
              styleClass="h-full min-w-[110px]"
              inputValue={
                selectedQuiz?.quiz_detail_json?.[i]?.answers?.[0]?.answer.text
              }
              valueUpdated={updateAnswerValue}
              index={i}
              hasFile={true}
              imageUrl={
                selectedQuiz?.quiz_detail_json && itm?.answers?.[0]?.answer?.url
                  ? imageUrl + itm?.answers?.[0]?.answer?.url
                  : selectedQuiz?.quiz_detail_json &&
                      itm?.answers?.[0]?.answer.fileId &&
                      typeof itm?.answers?.[0]?.answer.fileId !== "string"
                    ? URL.createObjectURL(itm?.answers?.[0]?.answer.fileId)
                    : undefined
              }
              handleImageChange={(image) => updateAnswerImage(image, i)}
              imageHeight="h-full"
              id={`file-input-matching-answer-${image_id + i}`}
              tabIndex={i + 2}
            />
          </div>
        </div>
        {selectedQuiz.quiz_detail_json?.length <= 3 && (
          <div className=" flex items-center mt-7">
            <button
              title={FA_LANG.ADD_CHOICE_ALT}
              className=" bg-bg-white w-6 h-6 rounded-full flex items-center justify-center text-gray-90 hover:bg-tertiary"
              onClick={() => handleAddInputs(i + 1)}
            >
              {icons.add}
            </button>
          </div>
        )}
      </div>
    ));
  };
  function handleQuestionAudioChange(audio: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_voice: audio,
      question_voice_link: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  const image_id = useId();

  return (
    <div className="flex flex-col gap-8 items-start w-full h-full">
      <ResponseInput
        inputValue={selectedQuiz.question}
        valueUpdated={handleQuestionChange}
        placeHolder={FA_LANG.MATCHING_QUESTION_PLACEHOLDER}
        handleImageChange={handleQuestionFileChange}
        id={`file-input-question-matching-${image_id}`}
        styleClass={"h-[200px] w-full"}
        index={100}
        hasFile={true}
        imageUrl={
          selectedQuiz.question_link
            ? imageUrl + selectedQuiz.question_link
            : selectedQuiz.question_file
              ? URL.createObjectURL(selectedQuiz.question_file)
              : undefined
        }
        imageHeight="h-[150px]"
        imageWidth="w-[150px]"
        maxLength={1000}
        questionInput={true}
        tabIndex={0}
        questionDirection={questionDirection}
        handleVoiceChange={handleQuestionAudioChange}
        hasAudio={true}
        inputVoice={selectedQuiz.question_voice_link}
      />
      <div className="flex w-full flex-col items-start gap-4 flex-grow p-[6px] h-full overflow-scroll">
        <div className="text-right text-gray-500 text-xs font-medium leading-none">
          {FA_LANG.MATCHING_CHOICE_TITLE}
        </div>
        <div
          className={`flex w-full  h-full ${
            selectedQuiz.quiz_detail_json?.length &&
            selectedQuiz.quiz_detail_json?.length <= 3
              ? "gap-0"
              : " gap-3"
          }`}
        >
          {renderInputs()}
        </div>
      </div>
    </div>
  );
}
